import { MultiStepModal } from '@frontend/payments-multistep-modal';
import { theme } from '@frontend/theme';
import { Modal, ModalProps } from '@frontend/design-system';
import { useRegisterTerminalState } from './hooks';
import { RegisterTerminalModalAllSteps } from './register-terminal-modal-all-steps';
import { StepperProps } from './types';

interface RegisterTerminalsProps {
  modalProps: Omit<ModalProps, 'children'>;
  locationId: string | undefined;
  stripeLocationId: string | undefined;
  closeModal: () => void;
  onTerminalRegistered: () => void;
}

export const RegisterTerminals = ({
  modalProps,
  locationId,
  stripeLocationId,
  closeModal,
  onTerminalRegistered,
}: RegisterTerminalsProps) => {
  const { initialStep, steps, type } = useRegisterTerminalState();

  return (
    <MultiStepModal
      as={Modal.Responsive}
      modalProps={modalProps}
      closeModal={closeModal}
      initialStep={initialStep}
      stepper={steps}
      maxWidth={parseFloat(theme.spacing(97))}
      stepperWidth={parseFloat(theme.spacing(20))}
      hideBackButton
    >
      <RegisterTerminalModalAllSteps
        onComplete={closeModal}
        onRegisterTerminal={onTerminalRegistered}
        Stepper={Stepper}
        locationId={locationId}
        stripeLocationId={stripeLocationId}
        type={type}
      />
    </MultiStepModal>
  );
};

const Stepper: React.FC<StepperProps> = ({ id, label, children }) => (
  <MultiStepModal.Step id={id.toString()} key={id} title={label}>
    {children}
  </MultiStepModal.Step>
);
